import '.gr{width:2.5rem;}.ssr-plugin'
import '.by{height:2.5rem;}.ssr-plugin'
import '.d{display:flex;}.ssr-plugin'
import '.t{align-items:center;}.ssr-plugin'
import '.ax{justify-content:center;}.ssr-plugin'
import '.h8{color:var(--palette-blue-700);}.ssr-plugin'
import '.h9{font-size:0.9rem;}.ssr-plugin'
import '.a5{font-weight:400;}.ssr-plugin'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { styled } from 'inlines'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { LinkAnchor } from '@app/components/core/link/LinkAnchor'
import { MouseEventHandler } from 'react'

export type SocialMediaButtonProps = {
  icon: IconProp
  label: string
  to?: string
  onClick?: MouseEventHandler<HTMLAnchorElement>
  isMobile?: boolean
}

export const SocialMediaButton = ({
  icon,
  label,
  to,
  onClick,
  isMobile,
}: SocialMediaButtonProps) => {
  return (
    <LinkAnchor
      to={to}
      onClick={onClick}
      style={{
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '0.5rem',
        cursor: 'pointer',
        padding: '0.75rem',
        borderRadius: '1.25rem',
        border: 'var(--border-subtle)',
        backgroundColor: 'var(--palette-white)',
        transition: 'background-color 0.2s ease',
        '&:hover': {
          backgroundColor: 'var(--palette-blue-50)',
        },
        width: isMobile ? '8rem' : '5.5rem',
        height: isMobile ? '8rem' : '5.5rem',
      }}
    >
      <div className="gr by d t ax h8"
        style={{
          fontSize: isMobile ? '3rem' : '2rem',
        }}
      >
        <FontAwesomeIcon icon={icon} />
      </div>
      <span className="h9 h8 a5"
      >
        {label}
      </span>
    </LinkAnchor>
  )
}
